import { TContentReportReason } from '@/types/Content.types';

// Mirrors the backend's ReportContentDto reason enum; the labels are the user-facing
// wording for each.
export const CONTENT_REPORT_REASONS: { value: TContentReportReason; label: string }[] = [
  { value: 'misinformation', label: 'Misinformation' },
  { value: 'spam', label: 'Spam' },
  { value: 'harmful', label: 'Harmful or dangerous' },
  { value: 'harassment', label: 'Harassment' },
  { value: 'sexual', label: 'Sexual content' },
  { value: 'off_topic', label: 'Off topic' },
  { value: 'other', label: 'Something else' },
];
